<mat-tab-group class="login-form-tabs login-section-wrapper" [(selectedIndex)]="selectedIndex">
  <mat-tab disabled>
    <ng-template matTabContent>
      <app-login-section (changeForm)="changeForm()" class="h-100"></app-login-section>
    </ng-template>
  </mat-tab>
  <mat-tab disabled>
    <ng-template matTabContent>
      <!-- <ng-container *ngIf="is_reset_password" class="d-flex justify-content-between align-items-center">
        <div class="reset-form-wrapper position-relative">
          <div class="mb-4">
            <div style="font-size:16px;" class="fw-bolder">Reset Password</div>
            <small class="text-secondary">
              You can reset your password here.
          </small>
          </div>
          <p [innerHtml]="verify_otp_success_msg" *ngIf="verify_otp_success_msg != '' && resetPassSelectedIndex != '2'"></p>
          <mat-tab-group [(selectedIndex)]="resetPassSelectedIndex" class="reset-pass-tabs">
            <mat-tab disabled>
              <mat-form-field appearance="outline">
                <input [formControl]="reset_mobile_email" type="text" autocomplete="off"  matInput placeholder="Please enter registered Email/Mobile" [disabled]="is_passReset">
                <mat-error>Mobile Number or Email Address is required</mat-error>
              </mat-form-field>
              <div class="mt-2 d-flex align-items-center justify-content-center flex-column">
                <small *ngIf="verify_otp_error_msg != ''" class="form-error-msg-text" [innerHTML]="verify_otp_error_msg"></small>
                <button mat-flat-button *ngIf="!show_otp_filed && !is_passReset" color="primary" class="reset-password-btn" [style.margin-top]="verify_otp_error_msg != '' ? '1rem' : '0'" (click)="reset_mobile_email.invalid ? validateRstPassField() : verifyOtp()">
                  Reset My Password
                </button>
                <mat-icon *ngIf="is_passReset"><mat-spinner diameter="24"></mat-spinner></mat-icon>
              </div>
            </mat-tab>
            <mat-tab disabled>
              <mat-form-field appearance="outline">
                <input [formControl]="otp_ctrl" autocomplete="off" matInput placeholder="Enter Verification Code">
                <mat-error>Please enter valid Verification Code</mat-error>
              </mat-form-field>
              <div class="d-flex justify-content-center align-items-center flex-column">
                <small *ngIf="otp_error_msg != ''" class="form-error-msg-text" [innerHTML]="otp_error_msg"></small>
                <button mat-flat-button *ngIf="show_otp_filed && !is_verifyingOtp" color="primary" class="verify-otp-btn" [style.margin-top]="otp_error_msg != '' ? '1rem' : '0'" (click)="verifyUserPassOtp()">Verify Verification Code</button>
                <mat-icon *ngIf="is_verifyingOtp"><mat-spinner diameter="24"></mat-spinner></mat-icon>
                <div *ngIf="show_otp_filed" class="mt-3">
                  <button mat-button class="resend-otp-btn" (click)="verifyOtp()" [disabled]="is_verifyingOtp" [disableRipple]="true">
                    Resend Verification Code
                  </button>
                </div>
              </div>
            </mat-tab>
            <mat-tab disabled>
              <form [formGroup]="passConfirmationForm" class="my-3">
                <mat-form-field appearance="outline">
                  <input formControlName="new_password" autocomplete="off" type="password" matInput placeholder="New Password">
                  <mat-error>Enter new Password</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <input formControlName="confirm_password" autocomplete="off" type="password" matInput placeholder="Confirm Password">
                  <mat-error>Please confirm your new Password</mat-error>
                </mat-form-field>
                <div class="mt-3 d-flex justify-content-center">
                  <button mat-flat-button color="primary" class="change-pass-btn" (click)="updatePassword()">
                    Change Password
                  </button>
                </div>
              </form>
            </mat-tab>
          </mat-tab-group>
          <mat-divider></mat-divider>
          <div class="text-center">
            <a class="tab-change-link" (click)="getToLoginPage()">Login</a>
          </div>
        </div>
      </ng-container> -->
      <app-reset-password (loginPage)="selectedIndex = 0" class="h-100"></app-reset-password>
    </ng-template>
  </mat-tab>
</mat-tab-group>
